import { Component } from 'react';

export default class ErrorBoundary extends Component {
  state = { error: null };

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error('Unhandled application render error:', error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main
        role="alert"
        dir="rtl"
        style={{
          maxWidth: 720,
          margin: '64px auto',
          padding: 24,
          background: 'var(--card-bg, #fff)',
          border: '1px solid var(--card-border, #e8e8e8)',
          borderRadius: 'var(--radius, 16px)',
          boxShadow: 'var(--shadow-sm)',
          textAlign: 'center',
        }}
      >
        <h1 style={{ marginBottom: 12 }}>صفحه با خطا روبه‌رو شد</h1>
        <p style={{ marginBottom: 20 }}>لطفاً صفحه را دوباره بارگذاری کنید.</p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            padding: '10px 20px',
            background: 'var(--green, #2e7d32)',
            borderRadius: 'var(--radius-sm, 8px)',
            color: '#fff',
          }}
        >
          بارگذاری دوباره
        </button>
      </main>
    );
  }
}
